import React, { useState, useEffect } from "react";
import { createEventId } from "./event-utils";

const EventModal = ({
  isOpen,
  onClose,
  onTitleChange,
  onAddEvent,
  onUpdateEvent,
  onDeleteEvent,
  selectedEvent,
}) => {
  const [eventTitle, setEventTitle] = useState(selectedEvent ? selectedEvent.title : "");
  const [showTitleError, setShowTitleError] = useState(false);

  const handleAddEvent = () => {
    if (eventTitle.trim() !== "") {
      setShowTitleError(false);
      onAddEvent({
        id: createEventId(),
        title: eventTitle,
        allDay: false,
      });
      setEventTitle("");
      onClose();
    } else {
      setShowTitleError(true);
    }
  };

  const handleUpdateEvent = () => {
    if (selectedEvent && eventTitle.trim() !== "") {
      onUpdateEvent({
        ...selectedEvent,
        title: eventTitle,
      });
      setEventTitle("");
      onClose();
    } else {
      setShowTitleError(true);
    }
  };

  const handleDeleteEvent = () => {
    if (selectedEvent) {
      onDeleteEvent(selectedEvent.id);
      setEventTitle("");
      onClose();
    }
  };

  useEffect(() => {
    if (selectedEvent) {
      setEventTitle(selectedEvent.title);
    }
  }, [selectedEvent]);

  return (
    isOpen && (
      <div className="modal" tabIndex="-1" role="dialog">
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">{selectedEvent ? "Update Event" : "Add Event"}</h5>
              <button type="button" className="btn-close" onClick={onClose}></button>
            </div>
            <div className="modal-body">
              <input
                type="text"
                placeholder="Event title"
                value={eventTitle}
                onChange={(e) => {
                  setEventTitle(e.target.value);
                  setShowTitleError(false);
                  onTitleChange(e.target.value);
                }}
                className={`form-control ${showTitleError ? "is-invalid" : ""}`}
              />
              {showTitleError && (
                <div className="invalid-feedback">Please enter a title for the event.</div>
              )}
            </div>
            <div className="modal-footer">
              {selectedEvent ? (
                <>
                  <button type="button" className="btn btn-danger" onClick={handleDeleteEvent}>
                    Delete
                  </button>
                  <button type="button" className="btn btn-primary" onClick={handleUpdateEvent}>
                    Update
                  </button>
                </>
              ) : (
                <button type="button" className="btn btn-primary" onClick={handleAddEvent}>
                  Add Event
                </button>
              )}
              <button type="button" className="btn btn-secondary" onClick={onClose}>
                Cancel
              </button>
            </div>
          </div>
        </div>
      </div>
    )
  );
};

export default EventModal;


// redux is a pattern and library for